module.exports = {

  // Change this to your firebase configuration! (Add Firebase to your web app)
    FIREBASE_CONFIG: {

      apiKey: "AIzaSyDWHy90VvARD7EY7fsLBydtlDzwP3Y0TcA",
      authDomain: "project-3261473790845899779.firebaseapp.com",
      databaseURL: "https://project-3261473790845899779.firebaseio.com",
      projectId: "project-3261473790845899779",
      storageBucket: "project-3261473790845899779.appspot.com",
      messagingSenderId: "1066321935089"
    },
};

window.config = {
    "appName": "Trick Strat™",
    "subTitle": "Esports Playbook",
    "version": "v1.05",
    "copyright": "© 2020 Ambrose Gaming",
    "twitter": "@TrickStrat",
    "privacyURL": "https://privacy.trickstrat.com",
    "termsURL": "https://terms.trickstrat.com",
    "copyrightURL": "https://copyright.trickstrat.com",
    "licenseURL": "https://license.trickstrat.com",
    "trickstratURL": "https://trickstrat.com",
    "maxStratCount": 9,
}



// WEBPACK FOOTER //
// ./src/app/config.js